import { Link } from "react-router-dom";
import styles from "./style.module.scss";

export const ReservationButton = () => {
  return (
    <Link to="/reservation">
      <nav className={styles.container}>
        <div className={styles.box}>
          ご予約は
          <br />
          こちら
        </div>
      </nav>
    </Link>
  );
};
